import { render, staticRenderFns } from "./FileAttachment.vue?vue&type=template&id=2bbbadde&scoped=true"
import script from "./FileAttachment.vue?vue&type=script&lang=js"
export * from "./FileAttachment.vue?vue&type=script&lang=js"
import style0 from "./FileAttachment.vue?vue&type=style&index=0&id=2bbbadde&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bbbadde",
  null
  
)

export default component.exports